// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxaut0 } from "../../../icons/mono/build/icon-axaut0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxautZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxaut0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxautZeroIcon.displayName = 'AxautZeroIcon';
}

export default AxautZeroIcon;